<template>
    <div>
        <div class="plugins-tips">
            <el-select v-model="query.emailShow" @change="currentEmail($event)" style="width: 100px; margin-right: 10px;">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="query.emailSearch" placeholder="Filter" @keyup.enter.native="handleEmailSearch" class="handle-input mr10"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="handleEmailSearch">搜索</el-button>
            <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："ID, 编辑者ID, 被指定玩家ID"</span> 

            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="postEmail()" style="float: right; margin-right: 20px">新增</el-button>
        </div>
        <el-table
            :data="email.tableData"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="tableCellStyle"
            @row-click="rowEmailClick"
            v-loading="email.loading"
            stripe
        >
            <el-table-column prop="id" label="ID" align="center"></el-table-column>
            <el-table-column prop="creatorId" label="编辑者ID" align="center"></el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column label="内容" align="center">
                <template slot-scope="scope">
                    <p class="cont">{{ scope.row.content }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat" align="center"></el-table-column>
            <el-table-column prop="emailCond" label="发送群体" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.emailCond == 0">
                        <span>全体用户</span>
                    </div>
                    <div v-if="scope.row.emailCond == 1">
                        <span>指定用户</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="emailShow" label="是否显示" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.emailShow == 0">
                        <el-button type="info" size="mini" @click="changeEmailShowState(scope.row)">已撤销</el-button>
                    </div>
                    <div v-if="scope.row.emailShow == 1">
                        <el-button type="success" size="mini" @click="changeEmailShowState(scope.row)">已发送</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="email.pageIndex"
                :page-size="email.pageSize"
                :total="email.pageTotal"
                @current-change="handleEmailPageChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { getEmail, updateEmailStatus } from '../../../api/gameconsole-mars.js'
import moment from 'moment'
import axios from 'axios'
export default {
    name: 'MarsEmail',
    data: function(){
        return {
            options: [{
                value: '',
                label: '全部'
            }, {
                value: '0',
                label: '已撤销'
            }, {
                value: '1',
                label: '已发送'
            }],

            query: {
                emailShow: '',  // 是否展示, '':全部, 0:已撤销, 1:已发送, 
                emailSearch: ''  // 邮件搜索
            },
            //邮件
            email: {
                tableData: [],
                pageIndex: 1,
                pageSize: 9,
                pageTotal: 1,
                loading: true
            }
        }
    },
    created() {
        this.initEmailData()
    },
    activated() {
        this.initEmailData()
    },
    methods: {
        initEmailData() {
            this.email.loading = true
            //发送请求
            let params = {'condition': this.query.emailSearch, 'emailShow': this.query.emailShow, 'pageIndex': this.email.pageIndex, 'pageSize': this.email.pageSize }
            getEmail(params).then(res => {
                if(res.data.code == 200) {
                    this.email.tableData = res.data.data.records
                    this.email.pageTotal = res.data.data.total
                }

                this.email.loading = false
            }).catch(err => {
                this.email.loading = false
            })
        },

        //进入新增页
        postEmail(id) {
            localStorage.setItem('emailId', id)
            setTimeout(() => {
                this.$router.push('/Email')
            }, 100);
        },

        //是否显示 事件
        changeEmailShowState(row) {
            // 二次确认
            this.$confirm('确定要变更状态吗？', '提示', {
                type: 'warning'
            }).then(() => {

                //判断 显示状态,  如果为 显示中就隐藏，隐藏中就改为显示，  //emailShow  0:隐藏 1:显示
                let emailShow = row.emailShow
                if (emailShow == 0) {
                    emailShow = 1 
                } else {
                    emailShow = 0
                } 
                
                //发送请求
                let params = {'id': row.id, 'emailShow': emailShow}
                updateEmailStatus(params).then(res => {
                    if (res.data.code == 200) {
                        row.emailShow = emailShow
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.success(res.data.message)
                    }
                }).catch(err => {
                    this.$message.error('请求失败')
                })
            }).catch(err =>{})
        },

        // 邮件查询条件下拉框
        currentEmail() {
            this.initEmailData()
        },

        // 邮件搜索框
        handleEmailSearch() {
            this.initEmailData()
        },

        // row点击  进入编辑页
        rowEmailClick(row, column) {
            if (column.label != '内容') return
            localStorage.setItem('emailId', row.id)
            setTimeout(() => {
                this.$router.push('/Email')
            }, 100);
        },

        //邮件 上一页 下一页
        handleEmailPageChange(pageIndex) {
            this.email.pageIndex = pageIndex
            this.initEmailData()
        },

        //el-Tbale 时间格式
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''

            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        tableCellStyle(row, column) {
            if (row.column.label == '内容') {
                return {'cursor': 'pointer'}
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }

    .cont {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
